/**
 * CPSC DISCLAIM Processing Type Validator
 */
import type { AppRecordValidateResult, NamePath } from '@xbcb/ui-types';
import { CpscProcessingType } from '__generated__/graphql';
import { PgaValidator } from 'libs/entryValidation/pga/types';
import type { CpscPga, CpscValidationArgs } from './types';
import {
  createValidationResult,
  mergeValidationResults,
  validateIntendedUse,
} from './cpscCommonValidation';

/**
 * CPSC DISCLAIM validator
 */
export class CpscDisclaimValidator implements PgaValidator<CpscPga> {
  /**
   * Check if this validator applies to the given PGA data
   * @return {boolean} True if processing type is DISCLAIM
   */
  isApplicable({ pga }: CpscValidationArgs): boolean {
    return pga?.processingType === CpscProcessingType.DISCLAIM;
  }

  /**
   * Validate DISCLAIM processing type fields
   * @return {AppRecordValidateResult} Validation result
   */
  validate({
    pga,
    tariffNamePath,
    pgaFlag,
  }: CpscValidationArgs): AppRecordValidateResult {
    const cpscPath: NamePath = [...tariffNamePath, 'pga', pgaFlag];
    const result = createValidationResult();

    const isEmptyDisclaim =
      !pga?.disclaimerCode && !pga?.intendedUseDetails?.code;
    if (isEmptyDisclaim) {
      return result;
    }

    if (!pga?.disclaimerCode) {
      result.validateFields.push([...cpscPath, 'disclaimerCode']);
    }

    const intendedUseResult = validateIntendedUse(pga, cpscPath);

    return mergeValidationResults(result, intendedUseResult);
  }
}
